import React from 'react';
import { Label } from 'common/components/Card/InfoCard/InfoCard.styled';

interface IProps {
  label: string;
  highlight?: boolean;
}

export const InfoCardLabel = ({ label, highlight = false }: IProps) => {
  return <Label $isBold={highlight}>{label}</Label>;
};
